import React, { Component } from 'react'
import {Button, Col, Modal, Row, Spin} from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Socket from '../../utils/sockets'
import {
  startDownload,
} from '../../actions/DownloadAction'
import {
  ValidateAssetExtensionVideo,
  ValidateAssetExtensionAudio,
  ValidateAssetExtensionImage,
  ValidateAssetExtensionFonts,
  ValidateAssetExtensionDocuments,
  ENDPOINT
} from '../../utils';
import {
  sendNotification,
} from '../../utils/index'
import BunkeyAPI from '../../api/BunkeyAPI'
import {  resumeDownloadCancel} from '../../actions/DownloadAction';
import axios from 'axios'
import fileExtension from 'file-extension';

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0",
};
class MultiDownloadModalFolder extends Component {

  _isMounted = false;

  constructor(props) {
    super(props)
    this.state = {
      filesList: [],
      images: [],
      videos: [],
      audios: [],
      fonts: [],
      documents: [],
      folders: [],
      others: [],
      loadingData: true
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.getAllFilesFromFolderId(this.props.id);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getAllFilesFromFolderId = async (id) => {
    const {workclient, clientShared, accessToken} = this.props;
    if (!workclient) {
      // const resp = await BunkeyAPI({
      //   url: `/downloads/${clientShared}/dowload/multiple`,
      //   method: 'POST',
      //   data: {
      //     files: [
      //       {
      //         "id": id
      //       }
      //     ]
      //   }
      // });
      // if(!this._isMounted) return;
      // this.setState({
      //   filesList: resp.data
      // }, () => {
      //   this.updateFileTypesList()
      // });
      const resp = await axios.post(`${ENDPOINT}downloads/${clientShared}/dowload/multiple`, 
        {
          files: [
            {
              "id": id
            }
          ]
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
        },
      );
      if(!this._isMounted) return;
      this.setState({
        filesList: resp.data,
        loadingData: true
      }, () => {
        this.updateFileTypesList()
      });
    } else {
      const resp = await BunkeyAPI({
        url: `/downloads/${workclient}/dowload/multiple`,
        method: 'POST',
        data: {
          files: [
            {
              "id": id
            }
          ]
        }
      });
      if(!this._isMounted) return;
      this.setState({
        filesList: resp.data,
        loadingData: true
      }, () => {
        this.updateFileTypesList()
      });

    }
  }

  updateFileTypesList = () => {
    const currentState = this.state;
    const {filesList} = currentState;
    filesList.forEach(function(file) {
      if (!file) return;
      const type = file.type;
      if(type === "bunker" || type === "folder"){
        currentState.folders.push(file)
      }else if (ValidateAssetExtensionImage(file.uuid)){
        currentState.images.push(file);
      }else if (ValidateAssetExtensionVideo(file.uuid)){
        currentState.videos.push(file);
      }else if (ValidateAssetExtensionAudio(file.uuid)){
        currentState.audios.push(file);
      }else if (ValidateAssetExtensionFonts(file.uuid)){
        currentState.fonts.push(file);
      }else if (ValidateAssetExtensionDocuments(file.uuid)){
        currentState.documents.push(file);
      }else{
        currentState.others.push(file);
      }
    });
    setTimeout(() => {
      currentState.loadingData = false;
      this.setState(currentState)
    }, 500);
  }

  handleValidExtension = (item) => {
    const extName = fileExtension(item.name);
    const extOriginalUrl = fileExtension(item.uuid);
    if (extName) {
      return extOriginalUrl === extName
        ? item.name
        : item.name + "." + fileExtension(item.uuid);
    } else {
      return item.name + "." + fileExtension(item.uuid);
    }
  };

  handleDownloadMultiple = async (quality) => {
    const { filesList } = this.state;
    const { workclient, intl } = this.props;
    if(filesList.length === 0){
      sendNotification('error', intl, `${intl.formatMessage({ id: 'empty-download-notification' })}`);
      return;
    }

    // Volvemos al flujo socket + Lambda: el servicio nuevo (startDownloadV2 ->
    // /v1/downloads-services) apunta a http://localhost:3084 en el gateway y en
    // produccion no hay nada escuchando ahi, asi que devolvia 500 en toda descarga.
    const uuid = Socket.getInstance().id
    this.props.startDownload({
      id: uuid,
      uuid: uuid,
      name: 'compressed',
      state: 'download_in_progress',
      client: !workclient
        ? uuid
        : workclient,
      quality,
    });

    const dataToDownloadClean = filesList.filter(e => e).map(e => ({
      ...e,
      name: this.handleValidExtension(e)
    }));

    Socket.getInstance().emit(
      'download_gpt_listener_from_lambda'
    ,{
      id: uuid,
      env: process.env.REACT_APP_BUNKEY_ENV ? process.env.REACT_APP_BUNKEY_ENV : 'qa',
      files: dataToDownloadClean,
    });
    this.props.resumeDownloadCancel()
  }

  render() {
    const {
      show,
      intl,
      newColor,
      handleMultiDownload
    } = this.props;

    const {
      images,
      videos,
      audios,
      fonts,
      documents,
      folders,
      others,
      loadingData,
      filesList
    } = this.state;

    return (
      <Modal
        visible={show}
        onCancel={() => this.props.resumeDownloadCancel()}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
      >
        <div style={{ color: '#6F6F6F', fontSize: 30, fontWeight: 700, margin: '20px 0 34px 0', }}>
        {intl.formatMessage({id: "multi-download-title"})} AQUI
        </div>
        <div style={{ color: '#6F6F6F', fontSize: 18, fontWeight: 400, marginBottom: 36, }}>
          {intl.formatMessage({id: "multi-download-subtitle"})}
        </div>

        {!loadingData && <div style={{ margin: '0 auto', width: '70%', marginBottom: 50, fontSize: 15, fontWeight: 700, }}>
            {filesList.length === 0 && <div
              style = {{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: 100,
              }}
            >
              <p style = {{
                fontSize: 15,
                fontWeight: 700,
                margin: 0,
                color: "#6F6F6F",
              }}>
                {intl.formatMessage({id: "empty-download-text"})}
              </p>
            </div>}
          {images.length > 0 && <Row type={'flex'} justify={'center'} align={'middle'} style={{ color: '#6F6F6F', borderBottom: '0.25px solid #cccccc', padding: '6px 0', }}>
            <Col span={3}>
              <div style={{ width: 15, height: 15, background: '#3D85FD', }}></div>
            </Col>
            <Col span={15}>
            {intl.formatMessage({id: "multi-download-images"})}
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {images.length}
            </Col>
          </Row>}
          {videos.length > 0 && <Row type={'flex'} justify={'center'} align={'middle'} style={{ color: '#6F6F6F', borderBottom: '0.25px solid #cccccc', padding: '6px 0', }}>
            <Col span={3}>
              <div style={{ width: 15, height: 15, background: '#FFB44F', }}></div>
            </Col>
            <Col span={15}>
            {intl.formatMessage({id: "multi-download-videos"})}
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {videos.length}
            </Col>
          </Row>}
          {audios.length > 0 && <Row type={'flex'} justify={'center'} align={'middle'} style={{ color: '#6F6F6F', borderBottom: '0.25px solid #cccccc', padding: '6px 0', }}>
            <Col span={3}>
              <div style={{ width: 15, height: 15, background: '#FFB44F', }}></div>
            </Col>
            <Col span={15}>
            {intl.formatMessage({id: "multi-download-audios"})}
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {audios.length}
            </Col>
          </Row>}
          {fonts.length > 0 && <Row type={'flex'} justify={'center'} align={'middle'} style={{ color: '#6F6F6F', borderBottom: '0.25px solid #cccccc', padding: '6px 0', }}>
            <Col span={3}>
              <div style={{ width: 15, height: 15, background: '#FFB44F', }}></div>
            </Col>
            <Col span={15}>
            {intl.formatMessage({id: "multi-download-fonts"})}
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {fonts.length}
            </Col>
          </Row>}
          {documents.length > 0 && <Row type={'flex'} justify={'center'} align={'middle'} style={{ color: '#6F6F6F', borderBottom: '0.25px solid #cccccc', padding: '6px 0', }}>
            <Col span={3}>
              <div style={{ width: 15, height: 15, background: '#3AA52B', }}></div>
            </Col>
            <Col span={15}>
            {intl.formatMessage({id: "multi-download-docs"})}
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {documents.length}
            </Col>
          </Row>}
          {folders.length > 0 && <Row type={'flex'} justify={'center'} align={'middle'} style={{ color: '#6F6F6F', borderBottom: '0.25px solid #cccccc', padding: '6px 0', }}>
            <Col span={3}>
              <div style={{ width: 15, height: 15, background: '#3AA52B', }}></div>
            </Col>
            <Col span={15}>
            {intl.formatMessage({id: "multi-download-folders"})}
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {folders.length}
            </Col>
          </Row>}
          {others.length > 0 && <Row type={'flex'} justify={'center'} align={'middle'} style={{ color: '#6F6F6F', borderBottom: '0.25px solid #cccccc', padding: '6px 0', }}>
            <Col span={3}>
              <div style={{ width: 15, height: 15, background: '#3AA52B', }}></div>
            </Col>
            <Col span={15}>
            {intl.formatMessage({id: "multi-download-others"})}
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              {others.length}
            </Col>
          </Row>}
          
        </div>}

        {loadingData && <div style={{ margin: '0 auto', width: '70%', marginBottom: 50, fontSize: 15, fontWeight: 700, }}>
          <div style={spinnerStyle}>
            <Spin spinning={true} />
          </div>
        </div>}

        <Row type={'flex'} justify={'center'} className="download-buttons">
          { filesList.length !== 0 && <Button 
              type="default"
              style={{
                width: "100%"
              }}
              disabled={loadingData}
              onClick={() =>{
                if (handleMultiDownload) {
                  handleMultiDownload();
                  return;
                }
                this.handleDownloadMultiple('original')
              }}
            >
                {intl.formatMessage({id: "download_asset"})}
              </Button>
          } 
          <Button
            style={{ color: newColor, borderColor: newColor, width: '100%' }}
            onClick={() => this.props.resumeDownloadCancel()}>{intl.formatMessage({ id: "cancel_button" })}</Button>
        </Row>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    show: state.downloads.showResumeDownload,
    id: state.downloads.showResumeDownloadId,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    workclient: state.client.workclient,
  }
}

const mapDispatchToProps = {
  startDownload,
  resumeDownloadCancel
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(MultiDownloadModalFolder)));
